// node modules
import PropTypes from 'prop-types';

// app modules: props
import RecipeImageProps from 'components/RecipeImage/RecipeImageProps';

export default {
  item: PropTypes.shape({
    id: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      }),
    ),
    book: PropTypes.shape({
      title: PropTypes.string,
      image_name: PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          first_name: PropTypes.string,
          last_name: PropTypes.string,
        }),
      ),
      image_permission: PropTypes.bool,
    }),
    title: PropTypes.arrayOf(PropTypes.string),
    subtitle: PropTypes.arrayOf(PropTypes.string),
    instagram_url: PropTypes.string,
    graphics: RecipeImageProps.graphics,
  }),
};
